import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "auth/msalConfig";
import { AuthMode } from "auth/types";
import { getAuthMode } from "config/config";

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const authMode = getAuthMode();

    if (authMode === AuthMode.MS_ENTRA) {
        return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};
